import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry } from "./sentry";
import App from "./App";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
